export default function Image({ src, alt, className, priority, ...props }) {
    return (<img src={src} alt={alt} className={className} loading={priority ? 'eager' : 'lazy'} {...props}/>);
}
